// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/scribe/svc_document_template.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { CatalogCloneOverride, CatalogCloneResult, CatalogStatus, CommunityDocumentTemplate, DocumentSectionSpec, DocumentTemplate, DocumentTemplateSummary } from "../../model/dto_scribe_catalog_pb.js";

/**
 * @generated from message com.diagnocat.scribe.GetDocumentTemplateReq
 */
export const GetDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetDocumentTemplateReq",
  () => [
    { no: 1, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetDocumentTemplateResp
 */
export const GetDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetDocumentTemplateResp",
  () => [
    { no: 1, name: "DocumentTemplate", kind: "message", T: DocumentTemplate },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetDocumentTemplateBySeriesIDReq
 */
export const GetDocumentTemplateBySeriesIDReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetDocumentTemplateBySeriesIDReq",
  () => [
    { no: 1, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetDocumentTemplateBySeriesIDResp
 */
export const GetDocumentTemplateBySeriesIDResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetDocumentTemplateBySeriesIDResp",
  () => [
    { no: 1, name: "DocumentTemplate", kind: "message", T: DocumentTemplate },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListDocumentTemplatesReq
 */
export const ListDocumentTemplatesReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListDocumentTemplatesReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Statuses", kind: "enum", T: proto3.getEnumType(CatalogStatus), repeated: true },
    { no: 4, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 100, name: "Offset", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListDocumentTemplatesResp
 */
export const ListDocumentTemplatesResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListDocumentTemplatesResp",
  () => [
    { no: 1, name: "DocumentTemplates", kind: "message", T: DocumentTemplateSummary, repeated: true },
    { no: 2, name: "Total", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListDocumentTemplateVersionsReq
 */
export const ListDocumentTemplateVersionsReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListDocumentTemplateVersionsReq",
  () => [
    { no: 1, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListDocumentTemplateVersionsResp
 */
export const ListDocumentTemplateVersionsResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListDocumentTemplateVersionsResp",
  () => [
    { no: 1, name: "DocumentTemplates", kind: "message", T: DocumentTemplate, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateDocumentTemplateReq
 */
export const CreateDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateDocumentTemplateReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "Sections", kind: "message", T: DocumentSectionSpec, repeated: true },
    { no: 9, name: "BaseSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus), opt: true },
    { no: 14, name: "SourceDocument", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateDocumentTemplateResp
 */
export const CreateDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateDocumentTemplateResp",
  () => [
    { no: 1, name: "DocumentTemplate", kind: "message", T: DocumentTemplate },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateDocumentTemplateDraftReq
 */
export const UpdateDocumentTemplateDraftReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateDocumentTemplateDraftReq",
  () => [
    { no: 1, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "Sections", kind: "message", T: DocumentSectionSpec, repeated: true },
    { no: 9, name: "SourceDocument", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateDocumentTemplateDraftResp
 */
export const UpdateDocumentTemplateDraftResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateDocumentTemplateDraftResp",
  () => [
    { no: 1, name: "DocumentTemplate", kind: "message", T: DocumentTemplate },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteDocumentTemplateReq
 */
export const DeleteDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteDocumentTemplateReq",
  () => [
    { no: 1, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteDocumentTemplateResp
 */
export const DeleteDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteDocumentTemplateResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreDocumentTemplateReq
 */
export const RestoreDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreDocumentTemplateReq",
  () => [
    { no: 1, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreDocumentTemplateResp
 */
export const RestoreDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreDocumentTemplateResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.CloneDocumentTemplateReq
 */
export const CloneDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CloneDocumentTemplateReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Overrides", kind: "message", T: CatalogCloneOverride, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CloneDocumentTemplateResp
 */
export const CloneDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CloneDocumentTemplateResp",
  () => [
    { no: 1, name: "Result", kind: "message", T: CatalogCloneResult },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetCommunityDocumentTemplateReq
 */
export const GetCommunityDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetCommunityDocumentTemplateReq",
  () => [
    { no: 1, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetCommunityDocumentTemplateResp
 */
export const GetCommunityDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetCommunityDocumentTemplateResp",
  () => [
    { no: 1, name: "Template", kind: "message", T: CommunityDocumentTemplate },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ImportCommunityDocumentTemplateReq
 */
export const ImportCommunityDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ImportCommunityDocumentTemplateReq",
  () => [
    { no: 1, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ImportCommunityDocumentTemplateResp
 */
export const ImportCommunityDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ImportCommunityDocumentTemplateResp",
  () => [
    { no: 1, name: "CommunityTemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentTemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "DocumentTemplateSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ReusedExisting", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.PublishCommunityDocumentTemplateReq
 */
export const PublishCommunityDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.PublishCommunityDocumentTemplateReq",
  () => [
    { no: 1, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Specialty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Location", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "Tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.PublishCommunityDocumentTemplateResp
 */
export const PublishCommunityDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.PublishCommunityDocumentTemplateResp",
  () => [
    { no: 1, name: "Template", kind: "message", T: CommunityDocumentTemplate },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UnpublishCommunityDocumentTemplateReq
 */
export const UnpublishCommunityDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UnpublishCommunityDocumentTemplateReq",
  () => [
    { no: 1, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UnpublishCommunityDocumentTemplateResp
 */
export const UnpublishCommunityDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UnpublishCommunityDocumentTemplateResp",
  [],
);

